<div class="modal-header">
  <h5 class="modal-title" id="emptyModalLabel">Hộp Thoại Trống</h5>
  <button type="button" class="btn-close" (click)="closeModal()" aria-label="Đóng">x</button>
</div>
<div class="modal-body">
  <form [formGroup]="uploadForm" (ngSubmit)="onSubmit()" enctype="multipart/form-data">
      <input type="file" formControlName="file" (change)="onFileChange($event)" />
      <button class="btn btn-outline-primary"  type="submit">Tải Tệp Lên</button>
    </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="closeModal()">Đóng</button>
 <!--  <button type="button" class="btn btn-outline-primary">Lưu thay đổi</button> -->
</div>
